export default __webpack_public_path__ + "static/intro-poster-680b146ea2db45312403fcf2f15854e8.avif";